import { useRouteMatch } from 'react-router';

export const useBuildRoutes = (route: string): string => {
  const { path } = useRouteMatch();

  return `${path}/${route}`;
};
